import { accountEntityName } from '../../../../../backend/features/accounts/shared';
import { createLogCustom } from '../../../../../backend/features/audit';
import { changeMembersRoleBulkActionEvent } from '../../../../../backend/features/audit/shared';
import { changeOrganizationMembersRoleBulkActionType, organizationEntityName, orgColumnForAuditIdReplacement, } from '../../../../../backend/features/organizations/shared';
import { allowOrgMembersEdit, getAccountsViewFilterNew, requireAnySystemPermission } from '../../../../../backend/features/permissions/shared';
import { forEachEntityRow } from '../../../../../backend/utils';
import { AuthError } from '@juvare/platform-app/App';
import { defineBulkAction } from '@juvare/platform-sdk-react/backend/features/bulk-actions';
import { handleChangeOrganizationMemberRole } from './handleChangeOrganizationMemberRole';
export const changeOrganizationMembersRole = defineBulkAction({
    type: changeOrganizationMembersRoleBulkActionType,
    onAuthBulkAction: (userContext, { createdBy, data }) => {
        if (!allowOrgMembersEdit(userContext.userState)) {
            throw new AuthError('Unauthorized');
        }
        const secureFilter = [...getAccountsViewFilterNew(userContext.userState), ...data.params.filter];
        if (!requireAnySystemPermission(userContext.userState, 'all-organizations-admin')) {
            secureFilter.push({ id: createdBy, op: '!=' });
        }
        return {
            secureFilter,
        };
    },
    onProcessBulkAction: (appContext, params) => {
        const accountStorage = appContext.storage(accountEntityName);
        const actionOwner = accountStorage.get(params.createdBy);
        const ids = [];
        forEachEntityRow(accountStorage, { filter: params.data.secureParams.secureFilter, orderBy: [{ column: 'email' }] }, (row, idx) => {
            const result = handleChangeOrganizationMemberRole({
                appContext,
                actionOwner,
                row,
                processedIndex: idx,
                accountStorage,
                secureBulkActionParams: params,
            });
            if (result.updated) {
                ids.push(row.id);
            }
            return result;
        }, params.updateTotalCount);
        const orgStorage = appContext.storage(organizationEntityName);
        const organization = orgStorage.get(params.data.params.organizationId);
        const logCustomStrict = createLogCustom(appContext.audit);
        logCustomStrict({
            eventType: changeMembersRoleBulkActionEvent,
            entity: organizationEntityName,
            entityId: organization.id,
            params: { ids, orgRole: params.data.params.newRole, auditColumnValue: organization.columns[orgColumnForAuditIdReplacement] },
        });
    },
});
